export default "__VITE_ASSET__R6$BqnbI__"